import Cookies from 'js-cookie'
// 全局token key
const TokenKey = 'Admin-Token'
// 全局user key
const UserKey = 'Admin-User'
// 全局 refresh key
const RefreshTokenKey = 'Admin-Refresh'
export function getToken() {
  return Cookies.get(TokenKey)
}

export function setToken(token) {
  Cookies.set(TokenKey,token)
  return Cookies.get(TokenKey)
}

// export function setToken(token) {
//   return Cookies.set(TokenKey, token)
// }

export function removeToken() {
  Cookies.remove(RefreshTokenKey)
  return Cookies.remove(TokenKey)
}

export function removeUser() {
  return Cookies.remove(UserKey)
}

export function setUser(user) {
  Cookies.remove(UserKey)
  Cookies.set(UserKey, user)
  return Cookies.get(UserKey)
}

export function getUser() {
  return Cookies.get(UserKey)
}

export function getRefreshToken(refreshToken) {
  return Cookies.get(RefreshTokenKey, refreshToken)
}



// WEBPACK FOOTER //
// ./src/utils/auth.js